import React, { useCallback, useEffect, useMemo } from 'react';
import { GECKO_CONSTS, GeckoField } from 'ui';

const KEY_FIELD = {
  key: 'value',
  label: 'API Key',
  description:
    'Enter your Ethos API key. This key is used to authenticate with the Ellucian Ethos API.',
  type: GECKO_CONSTS.FIELD_TYPE_PASSWORD,
};

const DEFAULT_KEY = '';

const EllucianAPIKeyField = ({ value, setValue }) => {
  useEffect(() => {
    if (!value) {
      setValue(DEFAULT_KEY);
    }
  }, [value]);

  const changeHandler = useCallback(
    (_key, value) => {
      setValue(value);
    },
    [setValue],
  );

  const values = useMemo(() => {
    return { value };
  }, [value]);

  return (
    <div className="EllucianAPIKeyField">
      <GeckoField
        field={KEY_FIELD}
        handler={changeHandler}
        values={values}
      />
    </div>
  );
};

export default EllucianAPIKeyField;
